
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Thirtinfivebusonrentinpune() {



  const cardData =
  {
    keyword: ' 35 Seater Bus on Rent in Pune',
    heading: 'Vaishnavi Travels: 35 Seater Bus on Rent in Pune',
    headingDescription: 'Vaishnavi Travels provides convenient and affordable 35 Seater Bus on Rent in Pune, perfect for weddings, school trips, corporate outings, and outstation group tours. Our buses are spacious, well-maintained, and equipped with comfortable seating, strong air-conditioning, and ample luggage space to make every journey smooth and enjoyable. With professional drivers, timely pickups, and flexible booking options, we ensure hassle-free transportation for all kinds of events and tours. Whether it’s a family function, religious yatra, weekend getaway, or business trip, Vaishnavi Travels guarantees safe, reliable, and comfortable 35 seater bus rental services in Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

  "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace and a proud symbol of Maratha heritage. Once the seat of power of the Maratha Empire, its mighty gates, sprawling gardens, and ruined bastions narrate tales of valor and glory. Though partially destroyed by a fire in 1828, the fort still stands as a majestic landmark. The evening light-and-sound show recreates the romance of Bajirao and Mastani and the grandeur of the Peshwas. Thousands of visitors explore its corridors, courtyards, and gardens every day. Shaniwar Wada remains Pune’s proud cultural and historic centerpiece."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, constructed in 1892, is a historic monument closely tied to India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. Today, it houses a museum displaying Gandhi’s personal belongings, photographs, and letters. Its majestic Italian arches, sprawling lawns, and colonial architecture make it a popular attraction. Tourists enjoy the calm and serene ambiance of its gardens while soaking in history. Aga Khan Palace stands as Pune’s inspirational monument of patriotism and sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 25 km from Pune, Sinhagad Fort is famous for the 1670 battle in which Tanaji Malusare fought heroically for Chhatrapati Shivaji Maharaj. Perched atop a hill, it offers panoramic views of the Sahyadris and trekking opportunities for adventure lovers. The fort is dotted with ancient bastions, temples, and memorials echoing Maratha bravery. In monsoon, mist and waterfalls add a magical touch to the trek. Local villagers serve traditional pithla-bhakri, making the trip even more authentic. Sinhagad is Pune’s perfect mix of history, nature, and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. Established more than 125 years ago, the temple is famous for its magnificent idol adorned with gold and jewels. During Ganesh Chaturthi, the temple becomes the epicenter of vibrant celebrations attracting lakhs of devotees. Beyond rituals, the temple is renowned for its charitable, cultural, and social initiatives. Tourists and devotees alike experience the spiritual energy and grandeur here. Dagdusheth Ganpati is Pune’s spiritual and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved in the 8th century, the Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. Featuring massive stone pillars, a sanctum, and a Nandi mandapa, it is a fine example of early Indian rock-cut architecture. Despite being located in the city center, the temple offers a peaceful and meditative environment. Evening prayers and chants fill the air with devotion and serenity. Tourists admire the craftsmanship and historical charm of this hidden heritage site. Pataleshwar Cave Temple is Pune’s spiritual retreat in the heart of the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure trove showcasing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits range from musical instruments, sculptures, and ornaments to everyday household objects of past centuries. The recreated Mastani Mahal is a highlight that fascinates history lovers. Students and tourists find the museum both educational and inspiring. It preserves India’s cultural traditions and artistry across eras. Raja Dinkar Kelkar Museum is Pune’s proud celebration of heritage, history, and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest heritage sites, offers a panoramic view of the city from its hilltop temple complex. The Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller temples and museums nearby add cultural depth to the visit. Visitors climb 103 stone steps to reach the top, combining devotion with a healthy trek. Sunrise and sunset views from here are truly mesmerizing. Parvati Hill is Pune’s sacred and scenic escape above the city."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort, located in Koregaon Park, is Pune’s global destination for spirituality, wellness, and mindfulness. Spread across beautifully landscaped gardens, it attracts seekers and tourists from across the world. The ashram offers meditation techniques, yoga practices, and personal growth workshops. Japanese Zen gardens and tranquil meditation halls create a serene atmosphere. Beyond spirituality, it promotes rejuvenation and holistic living. Osho Ashram is Pune’s international hub of peace, healing, and inner growth."
  },
  {
    "title": "Pu La Deshpande Garden (Okayama Friendship Garden)",
    "description": "Inspired by the famous Korakuen Garden in Japan, Pu La Deshpande Garden is Pune’s largest landscaped park. It is designed with flowing streams, stone bridges, manicured lawns, and seasonal flowers. Families enjoy picnics, peaceful walks, and photography in this lush setting. The garden is also a symbol of Indo-Japanese cultural friendship. Nature lovers find it refreshing throughout the year, especially in spring. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built across the Mutha River, is a popular weekend spot just outside Pune. It not only supplies water to the city but also offers stunning views of hills, backwaters, and sunsets. In monsoon, the overflowing dam creates breathtaking sights. Locals and tourists enjoy roadside snacks like roasted corn and tea along the banks. It is also the starting point for trips to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural getaway for families and travelers alike."
  }
],


 "services": [
{
"name": "35 Seater Bus Hire Pune",
"description": "Comprehensive 35 seater bus hire service in Pune, ideal for medium-sized groups seeking comfortable and reliable transportation. Whether for corporate events, school trips, family outings, or local tours, our fleet includes both AC and non-AC buses maintained to the highest standards. Professional drivers ensure safe and timely journeys, and flexible booking options cater to hourly, full-day, or multi-day needs."
},
{
"name": "Mid-Sized Group Bus Rental",
"description": "Specialized mid-sized group bus rentals in Pune, perfect for gatherings of up to 35 passengers. Our buses provide spacious interiors with ample legroom and luggage space, making them suitable for various occasions including weddings, religious ceremonies, corporate meetings, and sightseeing tours. Enjoy smooth rides with comfortable seating, air conditioning options, and experienced drivers who prioritize your convenience and safety."
},
{
"name": "AC 35 Seater Bus Pune",
"description": "Premium air-conditioned 35 seater bus rental in Pune offering a cool and comfortable travel experience for all weather conditions. Equipped with modern amenities like reclining seats, on-board entertainment, and sufficient storage, these buses are perfect for long-distance journeys, outstation trips, corporate travel, and special events. Our AC buses ensure a smooth ride with climate control and professional drivers familiar with Pune and surrounding areas."
},
{
"name": "School Trip 35 Seater Pune",
"description": "Safe and reliable 35 seater buses designed specifically for school trips in Pune. These buses feature child safety measures such as seat belts, clean and sanitized interiors, and attentive drivers trained in student transport. Ideal for educational tours, excursions, and field trips, our buses guarantee punctuality and comfort to make every school outing a memorable and hassle-free experience for students and staff alike."
},
{
"name": "Wedding Event Bus Hire 35 Seater",
"description": "Elegant 35 seater bus rental services tailored for wedding events in Pune. Our fleet includes well-decorated buses with options for AC and non-AC, ensuring your wedding guests travel in comfort and style. From Baraat processions to guest shuttles between hotels and venues, our buses provide reliable and timely service. Professional chauffeurs are courteous and trained to handle wedding day logistics smoothly, adding to the joy of your special day."
},
{
"name": "Office Team Bus Pune 35 Seater",
"description": "Dedicated 35 seater buses for office teams and corporate outings in Pune, perfect for team-building trips, conferences, and daily staff transport. These buses offer comfortable seating, air conditioning, and flexible scheduling to accommodate your business needs. Our reliable service focuses on punctuality and convenience, helping companies manage employee transportation efficiently while maintaining a professional standard."
},
{
"name": "35 Seater Tour Bus Hire Pune",
"description": "Explore Pune and nearby destinations with our 35 seater tour bus rentals designed for group sightseeing and leisure trips. Our buses provide ample space, comfortable seating, and options for air conditioning. Experienced drivers and customizable itineraries ensure a relaxed and enjoyable travel experience. Whether for religious tours, hill stations, or cultural visits, we provide dependable transportation tailored to your group’s preferences."
},
{
"name": "Non AC 35 Seater Rental Pune",
"description": "Affordable non-AC 35 seater bus rentals in Pune, suitable for budget-conscious travelers who do not require air conditioning but still want comfort and safety. Ideal for short city tours, local group events, school outings, and wedding transport. Our non-AC buses are regularly maintained and driven by professional chauffeurs to ensure smooth, punctual, and secure journeys."
},
{
"name": "Family Outing Bus 35 Seater",
"description": "Spacious 35 seater buses perfect for family outings and reunions in Pune. Enjoy group travel with ample seating, comfortable interiors, and sufficient luggage space for picnic gear or travel bags. Whether you are planning a day trip, religious pilgrimage, or leisure travel, our buses provide a relaxing and enjoyable experience with attentive drivers and flexible routes customized for family preferences."
},
{
"name": "35 Seater for Religious Trips",
"description": "Specialized 35 seater buses for religious tours and pilgrimages in Pune, designed to accommodate large groups traveling together to temples, shrines, or other sacred destinations. Our buses offer comfortable seating, options for AC or non-AC, and safe storage for belongings. Professional drivers ensure smooth navigation through pilgrimage routes and timely arrival for ceremonies or events."
},
{
"name": "Quick 35 Seater Bus Booking",
"description": "Fast and hassle-free booking service for 35 seater buses in Pune. Our easy online platform and responsive customer support make reserving the perfect bus simple and convenient. Whether for last-minute trips, corporate events, or family functions, enjoy instant confirmation, transparent pricing, and flexible payment options. We prioritize customer satisfaction with prompt pick-ups and reliable service."
},
{
"name": "Budget 35 Seater Bus Pune",
"description": "Cost-effective 35 seater bus rental options in Pune that don’t compromise on quality or safety. Ideal for schools, local tours, corporate groups, and social functions, our budget-friendly buses offer comfortable seating and dependable performance. Enjoy transparent pricing with no hidden charges, professional drivers, and customizable rental packages tailored to fit your financial plan."
},
{
"name": "35 Seater for Outstation Trips",
"description": "Reliable 35 seater bus rentals for outstation trips originating from Pune. Perfect for long-distance travel to neighboring cities and tourist spots, these buses come with experienced drivers familiar with highway routes and traffic regulations. We provide all-inclusive packages covering tolls, driver allowances, and fuel for stress-free journeys. Comfortable interiors and climate control options ensure your group enjoys every mile of the trip."
}
],
"tableData": [
["35 Seater Bus Hire Pune", "Mid-Sized Group Bus Rental"],
["AC 35 Seater Bus Pune", "School Trip 35 Seater Pune"],
["Wedding Event Bus Hire 35 Seater", "Office Team Bus Pune 35 Seater"],
["35 Seater Tour Bus Hire Pune", "Non AC 35 Seater Rental Pune"],
["Family Outing Bus 35 Seater", "35 Seater for Religious Trips"],
["Quick 35 Seater Bus Booking", "Budget 35 Seater Bus Pune"],
["35 Seater for Outstation Trips"]
],




"whychoose": [
  {
    "WhyChooseheading": "Affordable 35 Seater Bus on Rent in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers budget-friendly and reliable 35 seater bus rentals in Pune, perfect for medium to large group travel."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating",
    "WhyChoosedescription": "Our 35 seater buses provide ample legroom and comfortable seats to ensure a pleasant journey for all passengers."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each bus is regularly serviced and thoroughly cleaned to guarantee safety, hygiene, and a comfortable ride."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages to Suit Your Needs",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental options tailored to your travel plans and group size."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our professional drivers ensure safe, timely, and courteous service, with expert knowledge of Pune routes."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy all-inclusive pricing covering fuel, tolls, taxes, and driver allowances for a hassle-free rental experience."
  },
  {
    "WhyChooseheading": "Ideal for Corporate Events, Weddings, and Group Tours",
    "WhyChoosedescription": "Perfect for a variety of occasions including corporate events, weddings, sightseeing, and group outings."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Booking",
    "WhyChoosedescription": "Vaishnavi Travels provides round-the-clock customer assistance to help you with bookings and travel arrangements."
  }
]


































  }








const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels provide 35 seater buses on rent in Pune?',
      answer: 'Yes, Vaishnavi Travels offers well‑maintained 35 seater buses in Pune for rent. These are ideal for mid‑large group events, corporate travel, school trips, weddings, and outstation tours, ensuring both comfort and safety throughout the journey.',
    },
    {
      question: 'Can I choose between AC and Non‑AC 35 seater buses?',
      answer: 'Absolutely. We have both AC and Non‑AC 35 seater options to suit different budgets and comfort preferences. AC buses provide cooler, more luxurious travel; non‑AC ones are more economical but still maintain standards of hygiene and safety.',
    },
    {
      question: 'What is the approximate cost for renting a 35 seater bus in Pune?',
      answer: 'For local usage (around 8‑10 hours and ~100 km), the cost typically ranges between **₹11,500 to ₹17,000** depending on AC vs Non‑AC. For outstation trips (300 km/day or more), rates increase based on fuel, driver allowance, tolls, and distance.',
    },
    {
      question: 'What amenities come with a 35 seater bus rent?',
      answer: 'Our 35 seater buses usually include features such as comfortable seating (sometimes semi‑reclining), music / audio system, good legroom, overhead storage, and for AC models, climate control and adequate ventilation. Safety features like GPS, a first‑aid kit and well‑trained driver are standard.',
    },
    {
      question: 'Are extra charges like toll, parking or driver allowances included?',
      answer: 'No, these are usually extra. Our quotes will clearly show base rent plus additional costs like toll, parking, driver allowance (especially for overnight or multi‑day trips), and any permits or taxes required.',
    },
    {
      question: 'How far in advance should I book a 35 seater bus for Pune?',
      answer: 'To get better availability and rates, it’s advisable to book at least **3‑5 days** in advance for local trips, and **1‑2 weeks** ahead for outstation journeys or during peak seasons like wedding times or holidays.',
    },
    {
      question: 'Can the bus pick up from multiple locations and drop at different points?',
      answer: 'Yes. We can arrange multiple pickups and drop‑offs within Pune or on the route of travel. We plan the route so that extra time or distance is accounted for, and reflect that in the pricing to avoid surprises.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Harish Rao",
    position: "Team Leader, Summit Associates",
    feedback:
      "We hired a 35 seater AC bus from Vaishnavi Travels for our corporate offsite near Lonavala. The journey was very comfortable — seats were good, the bus was clean, AC worked well, and the driver was punctual. The amenities were as promised, and the experience added to the enjoyment of our trip. Definitely value for money.",
    rating: 5,
  },
  {
    name: "Ms. Richa Sharma",
    position: "Event Planner",
    feedback:
      "For a school tour, we booked a 35 seater non‑AC bus from Vaishnavi Travels. Even without AC, the ride was smooth, seats were decent, and luggage space was adequate. The driver was helpful and kept us on schedule. Booking was easy and their team was proactive in managing details. Would hire again!",
    rating: 5,
    style: "style-2",
  },
];
















































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "35 Seater Bus on Rent in Pune",
  "image": "https://vaishnavitravel.com/assets/images/35-seater-bus-pune.jpg",
  "description": "Book a 35 seater bus on rent in Pune with Vaishnavi Travels. Suitable for school trips, weddings, corporate events, family outings, and religious tours. Available in AC and Non AC variants with reliable drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1980"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5600",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/35-seater-bus-on-rent-in-pune"
  }
};


  return (
    <div>


<Helmet>
  <title>35 Seater Bus on Rent in Pune | AC & Non AC Group Bus Hire | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Book a 35 seater bus on rent in Pune with Vaishnavi Travels. Suitable for school trips, weddings, corporate events, family outings, and religious tours. Available in AC and Non AC variants with reliable drivers."
  />
  <meta
    name="keywords"
    content="35 Seater Bus Hire Pune, Mid-Sized Group Bus Rental, AC 35 Seater Bus Pune, School Trip 35 Seater Pune, Wedding Event Bus Hire 35 Seater, Office Team Bus Pune 35 Seater, 35 Seater Tour Bus Hire Pune, Non AC 35 Seater Rental Pune, Family Outing Bus 35 Seater, 35 Seater for Religious Trips, Quick 35 Seater Bus Booking, Budget 35 Seater Bus Pune, 35 Seater for Outstation Trips"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/18.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Thirtinfivebusonrentinpune;